<template>
  <div class="picture-wrapper" @mouseover="showRemove = true" @mouseleave="showRemove = false">
    <div class="picture-container">
      <el-upload class="picture"
                 :on-change="handlePreview"
                 action=""
                 :auto-upload="false"
                 :show-file-list="false">
        <base-avatar :circle="circle"
                     auto-size=""
                     @change="onChange"
                     :src="image"
                     :name="name"
                     :size="size"
                     class="picture-avatar"/>
      </el-upload>
      <base-button v-if="showRemove" @click="onRemoveClick" class="delete-icon" icon type="danger" round>
        <i class="el-icon-delete"></i>
      </base-button>
      <small v-if="removeClicked" class="description text-center mt-4">{{$t('generic.deletePictureTip')}}</small>
      <h6 class="description text-center mt-1">{{$t('generic.choosePicture')}}</h6>
    </div>
  </div>
</template>
<script>
  import { Upload } from 'element-ui'
  import FileService from 'src/services/FileService'
  import config from 'src/config/index'
  import { imageSizeOptions, UPLOAD_IMAGE_SIZES } from 'src/config/imageSizeOptions'

  export default {
    name: 'image-upload',
    components: {
      [Upload.name]: Upload
    },
    props: {
      src: {
        type: String,
        default: ''
      },
      name: String,
      size: {
        type: String,
        default: 'xl'
      },
      sizeType: {
        type: String,
        default: UPLOAD_IMAGE_SIZES.THUMB
      },
      circle: Boolean
    },
    data () {
      return {
        localSrc: null,
        showRemove: false,
        removeClicked: false
      }
    },
    computed: {
      image () {
        return this.localSrc || this.src || ''
      }
    },
    methods: {
      async handlePreview (file) {
        this.$emit('on-file-change', file)
        let res = await FileService.uploadFile({file: file.raw, name: file.name, public: true})
        let url = this.getModifiedUrl(res.data.public_url, this.sizeType)
        this.localSrc = url
        this.emitChange(url)
      },
      /**
       * Validates if given src is allowed.
       * We shouldn't allow custom image src other than those uploaded via storage api
       * @param {string} src
       * @return {boolean|*} whether image is valid
       */
      validateSrc (src) {
        return src.startsWith(config.STORAGE_BASE)
      },
      onChange (src) {
        if (this.validateSrc(src)) {
          this.emitChange(src)
        }
      },
      emitChange(src) {
        let url = this.getModifiedUrl(src, this.sizeType)
        this.$emit('on-change', url)
      },
      getModifiedUrl(url, type) {
        const imageTypes = imageSizeOptions.map(o => o.value).join('|');
        const regex = new RegExp(`\/(${imageTypes})\/`);
        return url ? url.replace(regex, `/${type}/`) : '';
      },
      onRemoveClick() {
        this.$emit('on-change', null)
        this.removeClicked = true
      }
    },
    watch: {
      image(newVal) {
        if (!this.validateSrc(newVal)) {
          this.emitChange(null)
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  .picture-wrapper {
    @apply flex relative;
    .picture-container {
      max-width: 200px;
    }
    .picture {
      @apply flex justify-center;
    }
  }

  .delete-icon {
    @apply absolute;
    top: -25px;
    right: -18px;
  }
</style>
<style lang="scss">
  .picture .el-upload__input {
    display: none !important;
  }
  .picture-wrapper .picture-avatar {
    @apply flex justify-center relative;
  }
  .picture-wrapper .picture-avatar,
  .picture-wrapper .picture-avatar img {
    width: auto;
    height: 100%;
  }
</style>
